import httpInterceptor from '../helpers/httpInterceptor';
const PRODUCT_END_POINT = process.env.REACT_APP_PRODUCT_API_ENDPOINT;

export default {
  downloadCSV(params) {
    return httpInterceptor.get(PRODUCT_END_POINT + 'createCSV', {
      params
    })
  }
}